import { useAuthStore } from "@/stores/authStore"
import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/admin")({
  beforeLoad: async () => {
    if (!useAuthStore.getState().hasPermission("view:admin_page")) {
      throw redirect({ to: "/" })
    }
  },
})
